import * as theme from "../theme";

import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import React from "react";
import styled from "styled-components";
import GuildLogoSrc from "../assets/images/guild_logo.png";
import HeaderText from "../components/HeaderText";
import Context from "../contexts/data";

export default function GuildConfirmation() {
  const { navigate, handleSubmit } = React.useContext(Context);

  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleNextStep = async () => {
    handleSubmit();

    navigate("result", "Guild Confirm");
  };

  return (
    <Wrapper>
      <HeaderText
        bigger_text="Final Step: Agree to Connect with Guild Mortgage."
        medium_text="(Check the box below and submit)"
      />
      <NoDataContainer>
        <NoDataText>You've been matched!</NoDataText>
      </NoDataContainer>
      <GuildBox>
        <LogoContainer>
          <GuildLogo src={GuildLogoSrc} alt="Guild Mortgage Logo" />
          <p>NMLS ID 3274</p>
        </LogoContainer>
        <GuildText>
          <p>
            Reverse mortgages available that meet your criteria. Check the box
            to be contacted and learn more.
          </p>
          <Checkbox size="large" onChange={handleChange} />
        </GuildText>
        <Button
          onClick={handleNextStep}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: theme.primary,
            textTransform: "capitalize",
            fontSize: {
              xs: "1rem",
              md: "1.5rem",
            },
            "&.Mui-disabled": {
              backgroundColor: theme.disabledBackground || "#d3d3d3",
              color: theme.disabledText || "#9e9e9e",
            },
          }}
          disabled={!checked}
        >
          Learn More
        </Button>
      </GuildBox>
    </Wrapper>
  );
}

const GuildBox = styled.div`
  display: flex;
  max-width: 1200px;
  padding: 2rem 1rem;
  gap: 3rem;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 750px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    color: #666666;
    font-size: 1rem;
    margin: 0;

    @media (max-width: 900px) {
      font-size: 0.75rem;
    }
  }
`;

const GuildLogo = styled.img`
  width: 221px;
`;

const GuildText = styled.div`
  max-width: 400px;
  display: flex;
  align-items: center;
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    color: #666666;
    font-size: 1.5rem;
    line-height: 1.5rem;
    margin: 0;

    @media (max-width: 900px) {
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }
`;

const Wrapper = styled(theme.column_align)`
  .phone_number_tcpa {
    display: none !important;
  }

  @media (max-width: ${theme.mobile}) {
    .phone_number_tcpa {
      display: block !important;
      width: 330px !important;
      max-height: inherit !important;
      > p {
        font-family: "Inter";
        font-style: normal;
        font-weight: 400;
        color: #666666;
        font-size: 14px;
        line-height: 16px;
        > a {
          color: ${theme.primary_light};
          text-decoration: none;
        }
      }
    }
  }
`;

const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 750px) {
    display: none;
  }
`;

const NoDataText = styled.p`
  color: #666666;
  font-size: 2rem;
  @media (max-width: ${theme.mobile}) {
    font-size: 1.5rem;
    text-align: center;
  }
`;
